export class CategoryFilter {
    startingIndex: number;
    pageSize: number;
    searchKey: string;
      constructor(obj?: CategoryFilter) {
        if (obj) {
          this.startingIndex = obj.startingIndex;
          this.pageSize = obj.pageSize;
          this.searchKey = obj.searchKey;
        }
      }
}
